module.exports = __webpack_public_path__ + "static/media/poupe.24c42cff.png";